module.exports = __webpack_public_path__ + "img/GroupBot-Logo-Dark.7e89846c.png";